import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import PlansSection from './components/PlansSection';
import TestimonialsSection from './components/TestimonialsSection';
import CtaSection from './components/CtaSection';

const HomePage = () => (
  <div className="min-h-screen bg-[#0A0A0F]">
    <Navbar />
    <main>
      <HeroSection />
      <FeaturesSection />
      <PlansSection />
      <TestimonialsSection />
      <CtaSection />
    </main>
    <Footer />
  </div>
);

export default HomePage;
